import { get, post, put, Delete } from "../axios";

// 课程包分类-列表
export const coursePackageClassifyList = (params) =>
  get("/web/course/package/classify/list", params);

// 课程包分类-全部分类
export const coursePackageClassifyListAll = (params) =>
  get("/web/course/package/classify/listAll", params);

// 课程包分类-新增
export const coursePackageClassifyAdd = (params) =>
  post("/web/course/package/classify/add", params);

// 课程包分类-编辑
export const coursePackageClassifyUpdate = (params) =>
  put("/web/course/package/classify/update", params);

// 课程包分类-删除
export const coursePackageClassifyDelete = (id) =>
  Delete("/web/course/package/classify/delete/" + id, "");

// 课程包classify-状态编辑
export const coursePackageClassifyStateUpdate = (params) =>
  put("/web/course/package/classify/state/update", params);
